// Module
var code = "<li class=\"qpui-breadcrumb-li\"> <span ng-bind=\"breadcrumbItemCtrl.divider\" class=\"qpui-breadcrumb-divider\"></span> <div ng-transclude></div> </li>";
// Exports
export default code;